<div class="manage">
  <div class="client-list">
    <h1>Liste Clients</h1>
    <app-list-clients class="list" [rowTable]="false" (updateClient)="setCurrentClient($event)"></app-list-clients>
  </div>
  <app-client-details class="detail" [users]="this.userService.users" [currentClient]="currentClient" (deleteClient)="deleteClient($event)"></app-client-details>
</div>

